/* Captain Retro — console configurator
   Reads the JSON block rendered by sections/cr-console-configurator.liquid,
   builds the version / upgrade / recap steps, and adds the chosen variants
   to the cart in one /cart/add.js request. */
(function () {
  'use strict';

  var KIT = 'Mod Kit';
  var VERSION = 'Version';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (k === 'text') n.textContent = attrs[k];
        else if (k === 'html') n.innerHTML = attrs[k];
        else if (k === 'class') n.className = attrs[k];
        else if (attrs[k] !== null && attrs[k] !== undefined && attrs[k] !== false) n.setAttribute(k, attrs[k]);
      });
    }
    (children || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }

  function optIndex(product, name) {
    return (product.options || []).findIndex(function (o) {
      return (typeof o === 'string' ? o : o.name) === name;
    });
  }

  /* The customer-selectable option: "Mod Kit" if present, otherwise the first
     option that isn't Version or Shopify's default Title (e.g. "Install Type"). */
  function choiceIndex(product) {
    var k = optIndex(product, KIT);
    if (k > -1) return k;
    return (product.options || []).findIndex(function (o) {
      var n = typeof o === 'string' ? o : o.name;
      return n !== VERSION && n !== 'Title';
    });
  }

  function optName(product, idx) {
    var o = (product.options || [])[idx];
    return o ? (typeof o === 'string' ? o : o.name) : '';
  }

  function variantValue(variant, idx) {
    return variant.options ? variant.options[idx] : variant['option' + (idx + 1)];
  }

  function init(root) {
    var dataEl = root.querySelector('[data-cr-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { console.error('CR configurator data', e); return; }

    var cfg = data.config || {};
    var versions = cfg.versions || [];
    var hasVersions = versions.length > 1;
    var discount = data.discount || 0;

    var products = (data.products || []).map(function (x) {
      var p = x.p;
      return {
        p: p,
        label: x.label || p.title,
        versions: x.versions || [],
        requiresRecap: x.requiresRecap === true,
        versionIdx: optIndex(p, VERSION),
        kitIdx: choiceIndex(p)
      };
    });

    var recapVariants = [];
    if (data.recapProduct && cfg.recap) {
      cfg.recap.forEach(function (r) {
        var v = data.recapProduct.variants.find(function (vv) { return String(vv.id) === String(r.variant); });
        if (v) recapVariants.push({ v: v, versions: r.versions || [] });
      });
    }

    var state = {
      version: hasVersions ? null : (versions[0] || null),
      product: null,      // product wrapper, or 'none'
      kit: null,
      recap: null,        // recap variant id or null
      recapConfirmed: false,
      prompt: {}
    };

    var $ = function (s) { return root.querySelector(s); };
    var stepVersion = $('[data-step="version"]');
    var stepUpgrade = $('[data-step="upgrade"]');
    var stepRecap = $('[data-step="recap"]');
    var addBtn = $('[data-add]');
    var errorEl = $('[data-error]');

    /* ---------- helpers ---------- */
    function compatible(w) {
      if (state.version && w.versions.length && w.versions.indexOf(state.version) === -1) return false;
      if (w.versionIdx > -1) {
        if (!state.version) return false;
        return w.p.variants.some(function (v) { return variantValue(v, w.versionIdx) === state.version; });
      }
      return true;
    }

    function variantsFor(w) {
      return w.p.variants.filter(function (v) {
        return w.versionIdx === -1 || variantValue(v, w.versionIdx) === state.version;
      });
    }

    function kitValues(w) {
      var seen = [];
      variantsFor(w).forEach(function (v) {
        var val = variantValue(v, w.kitIdx);
        if (seen.indexOf(val) === -1) seen.push(val);
      });
      return seen;
    }

    function resolveVariant(w) {
      return variantsFor(w).find(function (v) {
        return w.kitIdx === -1 || variantValue(v, w.kitIdx) === state.kit;
      }) || null;
    }

    function minPrice(w) {
      return Math.min.apply(null, variantsFor(w).map(function (v) { return v.price; }));
    }

    function recapOptions() {
      return recapVariants.filter(function (r) {
        return !r.versions.length || (state.version && r.versions.indexOf(state.version) > -1);
      });
    }

    function hasUpgrade() {
      return state.product && state.product !== 'none';
    }

    function radioCard(name, value, checked, title, sub, price, extra) {
      var id = name + '-' + Math.random().toString(36).slice(2, 8);
      var input = el('input', { type: 'radio', name: name, id: id, value: value, class: 'cr-radio' });
      input.checked = !!checked;
      var label = el('label', { for: id, class: 'cr-card' }, [
        el('span', { class: 'cr-card__title', text: title }),
        sub ? el('span', { class: 'cr-card__sub', text: sub }) : null,
        price ? el('span', { class: 'cr-card__price', text: price }) : null
      ]);
      var wrap = el('div', { class: 'cr-option' }, [input, label, extra || null]);
      return { wrap: wrap, input: input };
    }

    /* ---------- render steps ---------- */
    function renderVersions() {
      if (!hasVersions) { stepVersion.hidden = true; return; }
      stepVersion.hidden = false;
      var help = $('[data-version-help]');
      if (cfg.version_help) { help.textContent = cfg.version_help; help.hidden = false; }
      var box = $('[data-versions]');
      box.innerHTML = '';
      versions.forEach(function (v) {
        var rc = radioCard('cr-version', v, state.version === v, v);
        rc.input.addEventListener('change', function () {
          state.version = v;
          if (hasUpgrade()) {
            if (!compatible(state.product)) {
              state.product = null;
              state.kit = null;
            } else if (state.product.kitIdx > -1) {
              var kits = kitValues(state.product);
              if (kits.indexOf(state.kit) === -1) state.kit = kits[0] || null;
            }
          }
          state.prompt = {};
          renderAll();
        });
        box.appendChild(rc.wrap);
      });
    }

    function renderUpgrades() {
      var box = $('[data-upgrades]');
      box.innerHTML = '';
      var list = products.filter(compatible);
      var ready = !hasVersions || state.version;
      stepUpgrade.hidden = !ready || !products.length;
      if (stepUpgrade.hidden) return;

      if (!list.length) {
        box.appendChild(el('p', { class: 'cr-sub__note', text: 'No upgrades are listed for this version yet. Recap service is available below, or request a quote.' }));
      }

      var none = radioCard('cr-upgrade', 'none', state.product === 'none', 'None', 'Recap only');
      none.input.addEventListener('change', function () { state.product = 'none'; state.kit = null; renderAll(); });
      box.appendChild(none.wrap);

      list.forEach(function (w) {
        var vs = variantsFor(w);
        var multi = vs.length > 1 && new Set(vs.map(function (v) { return v.price; })).size > 1;
        var price = (multi ? 'from ' : '') + money(minPrice(w));
        var details = null;
        if (w.p.description) {
          details = el('details', { class: 'cr-details' }, [
            el('summary', { text: 'Details' }),
            el('div', { class: 'cr-details__body rte', html: w.p.description })
          ]);
        }
        var rc = radioCard('cr-upgrade', w.p.handle, state.product === w, w.label, w.p.title, price, details);
        rc.input.addEventListener('change', function () {
          state.product = w;
          var kits = w.kitIdx > -1 ? kitValues(w) : [];
          state.kit = kits.length ? kits[0] : null;
          state.prompt = {};
          if (!w.requiresRecap) state.recapConfirmed = false;
          renderAll();
        });
        box.appendChild(rc.wrap);
      });

      renderKit();
      renderPrompts();
    }

    function updateSourceNote() {
      var note = $('[data-kit-source-note]');
      if (!note) return;
      note.hidden = !(hasUpgrade() && state.product.kitIdx > -1 && state.kit && /source/i.test(state.kit));
    }

    function renderKit() {
      var wrap = $('[data-kit]');
      var box = $('[data-kit-options]');
      box.innerHTML = '';
      if (!hasUpgrade() || state.product.kitIdx === -1) { wrap.hidden = true; updateSourceNote(); return; }
      wrap.hidden = false;
      var w = state.product;
      var name = optName(w.p, w.kitIdx);
      var lbl = $('[data-kit-label]');
      var kitNote = $('[data-kit-note]');
      if (lbl) lbl.textContent = name === KIT ? 'Mod kit' : name;
      if (kitNote) kitNote.hidden = name !== KIT;
      kitValues(w).forEach(function (k) {
        var v = variantsFor(w).find(function (vv) { return variantValue(vv, w.kitIdx) === k; });
        var rc = radioCard('cr-kit', k, state.kit === k, k, null, v ? money(v.price) : null);
        rc.input.addEventListener('change', function () { state.kit = k; updateSourceNote(); renderSummary(); });
        box.appendChild(rc.wrap);
      });
      updateSourceNote();
    }

    function renderPrompts() {
      var wrap = $('[data-prompts]');
      wrap.innerHTML = '';
      var prompts = (cfg.prompts || []).filter(function (pr) {
        return hasUpgrade() && pr.product === state.product.p.handle && (!pr.version || pr.version === state.version);
      });
      wrap.hidden = !prompts.length;
      prompts.forEach(function (pr) {
        if (!state.prompt[pr.label]) state.prompt[pr.label] = pr.options[0];
        wrap.appendChild(el('p', { class: 'cr-sub__label', text: pr.label }));
        var box = el('div', { class: 'cr-options cr-options--pills' });
        pr.options.forEach(function (o) {
          var rc = radioCard('cr-prompt-' + pr.label.replace(/\W+/g, ''), o, state.prompt[pr.label] === o, o);
          rc.input.addEventListener('change', function () { state.prompt[pr.label] = o; });
          box.appendChild(rc.wrap);
        });
        wrap.appendChild(box);
      });
    }

    function recapPriceText(v) {
      if (hasUpgrade() && discount) {
        return money(v.price - discount) + ' with install (reg. ' + money(v.price) + ')';
      }
      return money(v.price);
    }

    function renderRecap() {
      var box = $('[data-recap]');
      var req = $('[data-recap-required]');
      box.innerHTML = '';
      var ready = !hasVersions || state.version;
      var opts = recapOptions();
      stepRecap.hidden = !ready || !opts.length;
      if (stepRecap.hidden) { state.recap = null; return; }

      if (state.recap && !opts.some(function (r) { return r.v.id === state.recap; })) state.recap = null;

      var required = hasUpgrade() && state.product.requiresRecap;
      if (required && state.recap === null && !state.recapConfirmed) state.recap = opts[0].v.id;

      if (opts.length === 1) {
        var r = opts[0];
        var id = 'cr-recap-' + Math.random().toString(36).slice(2, 8);
        var cb = el('input', { type: 'checkbox', id: id, class: 'cr-check' });
        cb.checked = state.recap === r.v.id;
        cb.addEventListener('change', function () {
          state.recap = cb.checked ? r.v.id : null;
          if (cb.checked) state.recapConfirmed = false;
          renderAll();
        });
        box.appendChild(el('div', { class: 'cr-checkrow' }, [
          cb,
          el('label', { for: id }, [
            el('span', { class: 'cr-card__title', text: 'Add recap service' }),
            el('span', { class: 'cr-card__sub', text: r.v.title }),
            el('span', { class: 'cr-card__price', text: recapPriceText(r.v) })
          ])
        ]));
      } else {
        var sel = el('select', { class: 'cr-select', 'aria-label': 'Recap service' });
        sel.appendChild(el('option', { value: '', text: 'None' }));
        opts.forEach(function (r) {
          var o = el('option', { value: String(r.v.id), text: r.v.title + ' — ' + recapPriceText(r.v) });
          if (state.recap === r.v.id) o.selected = true;
          sel.appendChild(o);
        });
        sel.addEventListener('change', function () {
          var found = opts.find(function (r) { return String(r.v.id) === sel.value; });
          state.recap = found ? found.v.id : null;
          if (found) state.recapConfirmed = false;
          renderAll();
        });
        box.appendChild(sel);
      }

      if (required) {
        req.hidden = false;
        req.textContent = data.recapRequiredText || 'This service requires a recapped console.';
        var cid = 'cr-confirm-' + Math.random().toString(36).slice(2, 8);
        var c = el('input', { type: 'checkbox', id: cid, class: 'cr-check' });
        c.checked = state.recapConfirmed;
        c.addEventListener('change', function () {
          state.recapConfirmed = c.checked;
          if (c.checked) state.recap = null;
          else if (state.recap === null) state.recap = opts[0].v.id;
          renderAll();
        });
        box.appendChild(el('div', { class: 'cr-checkrow cr-checkrow--confirm' }, [
          c, el('label', { for: cid, text: 'My console was recently recapped' })
        ]));
      } else {
        req.hidden = true;
      }
    }

    function selection() {
      var mod = hasUpgrade() ? resolveVariant(state.product) : null;
      var recap = state.recap ? recapVariants.find(function (r) { return r.v.id === state.recap; }) : null;
      return { mod: mod, recap: recap ? recap.v : null };
    }

    function validate(sel) {
      if (hasVersions && !state.version) return 'Choose your version.';
      if (!sel.mod && !sel.recap) return 'Choose an upgrade or add recap service.';
      if (hasUpgrade() && !sel.mod) return 'That option is not available for this version.';
      if (sel.mod && !sel.mod.available) return 'That option is currently unavailable.';
      if (hasUpgrade() && state.product.requiresRecap && !sel.recap && !state.recapConfirmed) {
        return 'Add recap service or confirm your console was recently recapped.';
      }
      return null;
    }

    function renderSummary() {
      var sel = selection();
      var lines = $('[data-lines]');
      lines.innerHTML = '';
      var total = 0;
      if (sel.mod) {
        var t = state.product.p.title + (sel.mod.title && sel.mod.title !== 'Default Title' ? ' — ' + sel.mod.title : '');
        lines.appendChild(el('li', {}, [el('span', { text: t }), el('span', { text: money(sel.mod.price) })]));
        total += sel.mod.price;
      }
      if (sel.recap) {
        lines.appendChild(el('li', {}, [el('span', { text: 'Recap Service — ' + sel.recap.title }), el('span', { text: money(sel.recap.price) })]));
        total += sel.recap.price;
        if (sel.mod && discount) {
          lines.appendChild(el('li', { class: 'cr-summary__discount' }, [
            el('span', { text: 'Recap bundle discount (applied in cart)' }),
            el('span', { text: '−' + money(discount) })
          ]));
          total -= discount;
        }
      }
      if (!sel.mod && !sel.recap) {
        lines.appendChild(el('li', { class: 'cr-summary__empty' }, [el('span', { text: 'Nothing selected yet' })]));
      }
      $('[data-total]').textContent = money(Math.max(total, 0));
      var err = validate(sel);
      addBtn.disabled = !!err;
      addBtn.dataset.reason = err || '';
    }

    function numberSteps() {
      var n = 1;
      [stepVersion, stepUpgrade, stepRecap].forEach(function (s) {
        var num = s.querySelector('.cr-step__num');
        if (!s.hidden) { num.textContent = n + '.'; n++; }
      });
    }

    function renderAll() {
      errorEl.hidden = true;
      renderVersions();
      renderUpgrades();
      renderRecap();
      numberSteps();
      renderSummary();
    }

    /* ---------- submit ---------- */
    root.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault();
      var sel = selection();
      var err = validate(sel);
      if (err) { errorEl.textContent = err; errorEl.hidden = false; return; }

      var common = { Console: data.console };
      if (hasVersions && state.version) common.Version = state.version;
      var notes = (root.querySelector('[data-notes]').value || '').trim();

      var items = [];
      if (sel.mod) {
        var props = Object.assign({}, common, state.prompt);
        if (notes) props.Notes = notes;
        if (state.product.requiresRecap && state.recapConfirmed) props['Recap'] = 'Customer confirms console was recently recapped';
        items.push({ id: sel.mod.id, quantity: 1, properties: props });
      }
      if (sel.recap) {
        var rprops = Object.assign({}, common);
        if (notes && !sel.mod) rprops.Notes = notes;
        items.push({ id: sel.recap.id, quantity: 1, properties: rprops });
      }

      addBtn.disabled = true;
      addBtn.classList.add('loading');
      var root_ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root_ + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart.');
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function (ex) {
          errorEl.textContent = ex.message;
          errorEl.hidden = false;
          addBtn.disabled = false;
          addBtn.classList.remove('loading');
        });
    });

    renderAll();
  }

  function boot() {
    document.querySelectorAll('[data-cr-configurator]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
